import React from 'react';

import Indicator from '../Indicator';
import {Reference} from '../../Structure';
import shouldComponentUpdate from './shouldComponentUpdate';


export default class Component extends React.Component {

  getDataPath() {
    return [];
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shouldComponentUpdate.call(this, nextProps, nextState);
  }

  renderLoading() {
    return <Indicator />;
  }

  renderLoaded() {
    throw new Error('renderLoaded not implemented');
  }

  isLoaded({data}) {
    if (data instanceof Reference) {
      const dataCursor = data.cursor(this.getDataPath());
      if (typeof dataCursor.deref() === 'undefined') {
        return false;
      }
    }
    return true;
  }

  render() {
    if (!this.isLoaded(this.props, this.state)) {
      return this.renderLoading();
    }
    return this.renderLoaded(this.props, this.state);
  }

}



// WEBPACK FOOTER //
// ./src/components/component/Component.js